import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DailyPerformance = {
	name: NAME,
	apiProvider,
	router,
};
